import { Jumbotron } from '../components'
import jumboData from '../fixtures/jumbo.json'
import React from 'react'

export function JumbotronContainer() {
    return (
        <Jumbotron.Container>
            {jumboData.map(item => (

                <Jumbotron key={item.id} direction={item.direction}>
                    <Jumbotron.Pane>
                        <Jumbotron.Title>{item.title}</Jumbotron.Title>
                        <Jumbotron.SubTitle>{item.subTitle}</Jumbotron.SubTitle>
                    </Jumbotron.Pane>
                    <Jumbotron.Pane>
                        <Jumbotron.Image src={`${process.env.PUBLIC_URL}${item.image}`} alt={item.alt} />
                    </Jumbotron.Pane>

                </Jumbotron>
            ))}
        </Jumbotron.Container>
    );
}

